import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { reset } from "../store";
import { TaskDetailContent } from "@/components/TaskDetailContent";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useFetchTask, useNextPendingTask } from "@labeling-tools/api/hooks";
import { useFetchJobTasks } from "@labeling-tools/api/hooks";
import { LoadingOverlay } from "@mantine/core";
import { AdminToolbar } from "@labeling-tools/ui-components/src/AdminToolbar";
import { HEADER_HEIGHT } from "@/config/data";
import { QaResultBanner } from "@/components/QaResultBanner";

export const TaskDetail = ({ mode }: { mode?: "admin" | "viewer" | "qa" }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");
  const { data: jobTasks, isLoading: jobTasksLoading } =
    useFetchJobTasks(jobId);
  const { data: nextPendingTask } = useNextPendingTask(jobId, mode !== "admin");
  const { data: task, isLoading: taskLoading } = useFetchTask(
    jobId,
    taskId || jobTasks?.tasks[0]?.id,
  );
  const qaResult =
    mode === "qa"
      ? nextPendingTask?.data?.product_association_result
      : task?.data?.product_association_result;

  useEffect(() => {
    if (task && !taskId && mode === "admin") {
      navigate(
        `/jobs/${jobId}/admin-product-association?taskId=${jobTasks?.tasks[0]?.id}`,
        { replace: true },
      );
    }
  }, [task]);

  // Reset Redux state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  if (jobTasksLoading || taskLoading) {
    return <LoadingOverlay />;
  }

  return (
    <>
      {jobTasks && task && mode === "admin" && (
        <div style={{ paddingTop: HEADER_HEIGHT }}>
          <AdminToolbar
            jobTasks={jobTasks}
            activeTask={task}
            headerHeight={HEADER_HEIGHT}
          />
        </div>
      )}
      {mode !== "viewer" && !!qaResult && (
        <div>
          <QaResultBanner result={qaResult} />
        </div>
      )}
      <TaskDetailContent mode={mode} />
    </>
  );
};
